import type { Comment } from "@/lib/humhub-api/types";

export type ReplyContext = { parentId: number; anchorId: number } | null;

// UI 調整用の表示件数（必要に応じてまとめて調整できるよう定数化）
export const INITIAL_VISIBLE = 2; // トップレベル表示件数
export const INITIAL_REPLIES_VISIBLE = 2; // 返信表示件数

// objectModel が優先。未指定の場合は replyCtx があれば返信扱い。
export const shouldPostAsReply = (
  replyCtx: ReplyContext,
  objectModel?: "comment" | "post",
) => objectModel === "comment" || (!!replyCtx && objectModel !== "post");

// objectId が優先。なければ replyCtx の parentId を使う。
export const resolveReplyParentId = (
  objectId: string | number | undefined,
  replyCtx: ReplyContext,
) => {
  if (objectId !== undefined && objectId !== null) {
    return Number(objectId);
  }
  if (replyCtx?.parentId) {
    return Number(replyCtx.parentId);
  }
  return null;
};

export const isUserAuthor = (
  comment: Comment,
  currentUserId?: number | string | null,
) => {
  if (!currentUserId) return false;
  const authorId = comment.user?.id || comment.createdBy?.id;
  return String(authorId) === String(currentUserId);
};
